/**
 * Marks a fixed bottom bar while the site footer is in view, so its `data-over-footer:` styles slide it away. Pulling
 * past the end of a page on iOS then shows the footer, not a bar left floating over the overscroll.
 *
 * @param {HTMLElement} bar the fixed bottom bar
 * @param {HTMLElement} footer the site footer
 * @returns {void}
 */
export function hideOverFooter(bar, footer) {
    new IntersectionObserver((entries) => bar.toggleAttribute('data-over-footer', entries.at(-1).isIntersecting)).observe(footer);
}
